import axios from 'axios';

const api = axios.create({ baseURL: window.Config.BASE_URL });

export { api };

export default {
	carregarVotacao: idVotacao => api.get('votacao/' + idVotacao + '/opcoes'),

	listarVotacoes: () => api.get('votacao')
};